import { Utils } from './utils';
import { Forms } from './forms';
const formSelector = ".enquiry-form";
const validationRules = {
    loanType: {
        required: true,
    },
    loanChargeType: {
        required: true,
    },
    propertyType: {
        required: true,
    },
    borrowAmount: {
        required: true,
    },
    borrowTime: {
        required: true,
    },
    title: {
        required: true,
    },
    firstName: {
        required: true,
    },
    lastName: {
        required: true,
    },
    email: {
        required: true,
        email: true,
    },
    phone: {
        required: true,
        phone: true
    },
    postcode: {
        required: true,
        postcode: true
    },
    callTime: {
        required: true,
    },
    loanSpeed: {
        required: true,
    },
    privacyPolicyAccepted: {
        required: true,
    },
};
const validationMessages = {
    loanType: {
        required: "Please select a valid reason for your loan",
    },
    loanChargeType: {
        required: "Please select a charge type for your loan",
    },
    propertyType: {
        required: "Please select the type of property you wish to get a loan for",
    },
    borrowAmount: {
        required: "Please enter the amount you wish to borrow",
    },
    borrowTime: {
        required: "Please enter how long you intend to borrow this money",
    },
    title: {
        required: "Please provide a title, if you dont wish to use a title you can choose \"Prefer not to say\"",
    },
    firstName: {
        required: "Please provide your first name",
    },
    lastName: {
        required: "Please provide your last name",
    },
    email: {
        required: "Please enter your email",
        email: "Please enter a valid email address"
    },
    phone: {
        required: "Please provide a phone number for contact purposes",
    },
    postcode: {
        required: "Please provide a valid postcode",
        postcode: "Please provide the postcode in a valid format"
    },
    callTime: {
        required: "Please provide a time you prefer to be contacted if you dont have a preference choose \"Anytime\"",
    },
    loanSpeed: {
        required: "Please provide a timeframe you need your loan within",
    },
    privacyPolicyAccepted: {
        required: "Please accept our privacy policy",
    },
};
const form = document.querySelector(formSelector);
let loanButtons;
let propertyTypeDropdown;
let propertyTypeWarning;
let loanChargeTypeDropdown;
let borrowAmountField;
let borrowTimeLabel;
let borrowTimeField;
function SetFieldBounds(button) {
    if (borrowTimeField !== null && borrowTimeLabel !== null && borrowAmountField !== null) {
        const amountField = borrowAmountField;
        const timeField = borrowTimeField;
        let netLoanSizeMin;
        let netLoanSizeMax;
        let loanTermMin;
        let loanTermMax;
        if (button.checked) {
            if (button.id.toLowerCase() === "bridging") {
                netLoanSizeMin = 25000;
                netLoanSizeMax = 500000;
                loanTermMin = 1;
                loanTermMax = 18;
            }
            else {
                netLoanSizeMin = 10000;
                netLoanSizeMax = 500000;
                loanTermMin = 36;
                loanTermMax = 360;
            }
            amountField.placeholder = `${Utils.toCurrency(netLoanSizeMin, 'GBP')} - ${Utils.toCurrency(netLoanSizeMax, 'GBP')}`;
            amountField.min = netLoanSizeMin.toString();
            amountField.max = netLoanSizeMax.toString();
            if (parseInt(amountField.value) > netLoanSizeMax) {
                amountField.value = netLoanSizeMax.toString();
            }
            else if (parseInt(amountField.value) < netLoanSizeMin) {
                amountField.value = netLoanSizeMin.toString();
            }
            timeField.placeholder = `${loanTermMin} months - ${loanTermMax} months`;
            timeField.min = loanTermMin.toString();
            timeField.max = loanTermMax.toString();
            if (parseInt(timeField.value) > loanTermMax) {
                timeField.value = loanTermMax.toString();
            }
            else if (parseInt(timeField.value) < loanTermMin) {
                timeField.value = loanTermMin.toString();
            }
        }
    }
}
/**
 * Sets the state of the loan buttons to a specific state and disables them.
 * @param loanButtons The NodeList of loan buttons to be updated.
 * @param stateId The ID of the button to be set as active, representing the loan type.
 */
function ForceTermLoanButtonState(loanButtons, stateId) {
    loanButtons.forEach((button) => {
        let buttonElement = button;
        if (buttonElement.id.toLowerCase() === stateId) {
            buttonElement.click();
        }
        else {
            buttonElement.parentElement.classList.add("disabled");
            buttonElement.disabled = true;
        }
    });
}
/**
 * Sets the loan charge type dropdown to a specific state and disables it.
 * @param loanChargeTypeDropdown The dropdown element to be updated.
 * @param stateId The value to set for the dropdown, representing the loan charge type.
 */
function SetLoanChargeTypeDropdownState(loanChargeTypeDropdown, stateId) {
    if (loanChargeTypeDropdown !== null) {
        loanChargeTypeDropdown.value = stateId;
        loanChargeTypeDropdown.classList.add("pe-none"); // Remove pointer events
        loanChargeTypeDropdown.classList.add("disabled");
    }
}
/**
 * When a user selects "Residential" from the property type dropdown, this function
 * should execute to set the loan type to "term loan" and the loan charge type to "Second Charge".
 * @param htmlPropertyTypeDropdown The dropdown element for property type selection.
 * @param htmlPropertyTypeWarning The warning element to display when "Residential" is selected.
 * @param loanButtons The NodeList of loan buttons to be updated.
 * @param htmlLoanChargeTypeDropdown The dropdown element for loan charge type selection.
 */
function SetResidentialLoanLogic(htmlPropertyTypeDropdown, htmlPropertyTypeWarning, loanButtons, htmlLoanChargeTypeDropdown) {
    // If the user selects "Residential" from the property type dropdown show the warning text so 
    // they userstand the logic that will happen
    if (htmlPropertyTypeDropdown.value === "Residential") {
        htmlPropertyTypeWarning.classList.remove("d-none");
        // Set the loan type to "term loan" and remove ability to change it
        ForceTermLoanButtonState(loanButtons, "termloan");
        // Set the loan charge type dropdown to "Second Charge" and remove ability to change it
        SetLoanChargeTypeDropdownState(htmlLoanChargeTypeDropdown, "Second Charge");
    }
    else {
        htmlPropertyTypeWarning.classList.add("d-none");
        // unlock the loan type allowing users to change it
        loanButtons.forEach((button) => {
            let buttonElement = button;
            buttonElement.parentElement.classList.remove("disabled");
            buttonElement.disabled = false;
        });
        // unlock the loan charge type dropdown allowing users to change it
        if (htmlLoanChargeTypeDropdown !== null) {
            htmlLoanChargeTypeDropdown.classList.remove("pe-none"); // Restore pointer events
            htmlLoanChargeTypeDropdown.classList.remove("disabled");
        }
    }
}
/**
 * Initializes form validation and submission for the Enquire Now form, with the GAEvent object configured for tracking.
 * @param formSelector The CSS selector for the form to be validated.
 * @param validationRules The validation rules to be applied to the form fields.
 * @param validationMessages The validation messages to be displayed for each field.
 */
function initializeFormValidation(formSelector, validationRules, validationMessages = undefined) {
    const { landingPage, conversionPagePath, gtmCode, spotCode, campaignName, campaignTerm, campaignMedium } = Utils.GetTrackingDataFromHiddenFields();
    let enquiryFormGAEvent = {
        event: 'enquiry-form_submission',
        attributes: {
            landingPage: landingPage,
            conversionPagePath: conversionPagePath,
            gtmCode: gtmCode,
            source: spotCode,
            campaignName: campaignName,
            campaignTerm: campaignTerm,
            campaignMedium: campaignMedium,
        }
    };
    Forms.initializeFormValidation(formSelector, validationRules, validationMessages, enquiryFormGAEvent);
}
window.addEventListener("load", () => {
    var _a, _b;
    // Initializes form validation and submission for the Enquire Now form, if
    // one is present on the form. Successful submission results in a redirect to a thank you
    // page, since we validate server side the only failure mode is recapture failure.
    initializeFormValidation(formSelector, validationRules, validationMessages);
    if (form !== null) {
        loanButtons = form.querySelectorAll("input[name='loanType']");
        borrowAmountField = form.querySelector("input[name='borrowAmount']");
        borrowTimeLabel = form.querySelector("label[for='borrowTime']");
        borrowTimeField = form.querySelector("input[name='borrowTime']");
        loanButtons.forEach((button) => {
            SetFieldBounds(button);
            button.addEventListener("click", () => {
                SetFieldBounds(button);
            });
        });
        propertyTypeDropdown = form.querySelector("select[name='propertyType']");
        propertyTypeWarning = (_b = (_a = form.querySelector(".text-warning[for='propertyType']")) !== null && _a !== void 0 ? _a : form.querySelector(".text-warning-emphasis[for='propertyType']")) !== null && _b !== void 0 ? _b : form.querySelector(".alert-warning[for='propertyType']");
        loanChargeTypeDropdown = form.querySelector("select[name='loanChargeType']");
        if (propertyTypeDropdown !== null && propertyTypeWarning !== null) {
            SetResidentialLoanLogic(propertyTypeDropdown, propertyTypeWarning, loanButtons, loanChargeTypeDropdown);
            propertyTypeDropdown.addEventListener("change", () => {
                SetResidentialLoanLogic(propertyTypeDropdown, propertyTypeWarning, loanButtons, loanChargeTypeDropdown);
            });
        }
    }
});
